// @flow
export const filterId: 'sellPoint' = 'sellPoint';
